import React, { useState } from "react";
import { useDetailsContext } from "../details";

import { Spinner } from 'reactstrap';

import "../../assets/OpenSans-Bold-bold"
import "../../assets/OpenSans-Regular-normal"

import { PdfExportValues } from "./PdfExportValues";
import { PdfExportHeader } from "./PdfExportHeader";
import { PdfExportTable } from "./PdfExportTable";
import { PdfExportElevationImage } from "./PdfExportElevationImage";
import { PdfExportMapImage } from "./PdfExportMapImage";

const DownloadPdfButton = ({ activityDetails, handleDownloadPDF }) => {
  const [state] = useDetailsContext();
  const hasData = !!state.selectedRoute;
  const summaryUnitLabels = state.userPrefUnits;
  const [isLoading, setLoad] = useState(false);
  
  if (! hasData) {
    return <div/>
  }

  const createPDF = async () => {
    setLoad(true);
    const jsPDF = await import("jspdf");
    const autoTable = await import("jspdf-autotable");

    print(jsPDF.default, autoTable.default).then((pdf) => {
      console.log("Finished creating pdf, now saving");
      const currentTime = new Date();
      const currentLocaleDate = currentTime.toLocaleDateString();
      pdf.save(`${currentLocaleDate}_${activityDetails.title}_waldup.pdf`);
      setLoad(false);
    })
  }

  const print = async (jsPDF) => {
    const waypointData = PdfExportValues(state.waypoints, summaryUnitLabels);
    const pdf = new jsPDF("p", "px", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    pdf.setFont('OpenSans-Regular','normal');


    const makeDisclaimer = () => {
      const disclaimer = `By using our services you agree to the inherent risks of sports activities, such as trail running. All information provided by Waldup is informational only and does not substitute any professional advice. Use solely your own risk.`;
      const splitDisclaimer = pdf.splitTextToSize(disclaimer, 370);
      pdf.setTextColor("#014d72");
      pdf.setFontSize(8);
      pdf.text(
        splitDisclaimer,
        225,
        pdf.internal.pageSize.getHeight() - 15,
        "center"
      );
    };

    const makeSecondPage = () => {
      if (state.waypoints.length > 8) {
        pdf.addPage();
        pdf.setPage(2);
        makeDisclaimer();
        pdf.setPage(1);
      }
    };

    const executePdfExportElevationImage = (startElevationImageY) => {
      return new Promise((resolve) => {
        PdfExportElevationImage(pdf, pdfWidth, startElevationImageY)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            console.error('Error in PdfExportElevationImage:', error);
            resolve();
          });
      });
    };

    const executePdfExportMapImage = (startMapImageY, maxMapHeight) => {
      return new Promise((resolve) => {
        PdfExportMapImage(pdf, pdfWidth, startMapImageY, maxMapHeight)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            console.error('Error in PdfExportMapImage:', error);
            resolve();
          });
      });
    };
    

    const mapFirst = true;
    let startTableY = 500;
    let startElevationImageY = 125;
    let startMapImageY = 225;
    let maxMapHeight = startTableY - startMapImageY;

    PdfExportHeader(pdf, activityDetails, summaryUnitLabels);
    makeDisclaimer();
    makeSecondPage();

    if (mapFirst) {
      startTableY = 500;
      startElevationImageY = 380;
      startMapImageY = 110;
      maxMapHeight = startElevationImageY - startMapImageY;
    }

    console.log("Start image generation");
    await Promise.all([
      executePdfExportElevationImage(startElevationImageY),
      executePdfExportMapImage(startMapImageY, maxMapHeight)
    ]);

    PdfExportTable(pdf, startTableY, pdfWidth, summaryUnitLabels, waypointData);      
    
    return pdf;
  };

  return (
    <React.Fragment>
      {/* While isLoading == true, show preloader */}
      {isLoading ? (
        <div className="wrapper">
          <span>Creating PDF ...</span>
          <Spinner className="spinner-border text-primary" animation="border" role="status">
          </Spinner>
        </div>
      ) : null}
      <div
        title="Export to PDF"
        className="btn btn-light control-button"
        onClick={(e) => {
          state.userStripeLevel !== "free" ? createPDF() : handleDownloadPDF();
        }}
      >
        <i className="far fa-file-pdf"></i>
          Export to PDF
      </div>
    </React.Fragment>
  );
};

export default DownloadPdfButton;
